var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_557_147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V6.66667H0V0Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.66684H32V13.3335H0V6.66684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13.3334H32V20.0001H0V13.3334Z",
    fill: "#128807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 12.6667C17.4724 12.6667 18.6663 11.4728 18.6663 10.0001C18.6663 8.52731 17.4724 7.3334 15.9997 7.3334C14.5269 7.3334 13.333 8.52731 13.333 10.0001C13.333 11.4728 14.5269 12.6667 15.9997 12.6667Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 12.3334C17.2883 12.3334 18.333 11.2887 18.333 10.0001C18.333 8.71141 17.2883 7.66674 15.9997 7.66674C14.711 7.66674 13.6663 8.71141 13.6663 10.0001C13.6663 11.2887 14.711 12.3334 15.9997 12.3334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 10.4667C16.2574 10.4667 16.4663 10.2578 16.4663 10.0001C16.4663 9.74234 16.2574 9.5334 15.9997 9.5334C15.7419 9.5334 15.533 9.74234 15.533 10.0001C15.533 10.2578 15.7419 10.4667 15.9997 10.4667Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2973 10.4245C18.363 10.4331 18.4233 10.3869 18.432 10.3212C18.4406 10.2555 18.3944 10.1952 18.3287 10.1865C18.263 10.1779 18.2027 10.2241 18.194 10.2898C18.1854 10.3555 18.2316 10.4158 18.2973 10.4245Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 12.3334L16.0797 10.9334L15.9997 10.2667L15.9197 10.9334L15.9997 12.3334Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1092 11.0047C18.1704 11.0301 18.2406 11.001 18.266 10.9398C18.2914 10.8785 18.2623 10.8083 18.201 10.783C18.1398 10.7576 18.0696 10.7867 18.0443 10.8479C18.0189 10.9091 18.048 10.9793 18.1092 11.0047Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3958 12.2539L15.8354 10.9223L15.9307 10.2577L15.6808 10.8809L15.3958 12.2539Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7773 11.5164C17.8299 11.5568 17.9052 11.5469 17.9456 11.4943C17.9859 11.4417 17.976 11.3664 17.9234 11.326C17.8708 11.2857 17.7955 11.2956 17.7552 11.3482C17.7148 11.4008 17.7247 11.4761 17.7773 11.5164Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.833 12.0208L15.6023 10.8484L15.8663 10.231L15.4637 10.7684L14.833 12.0208Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3243 11.9249C17.3646 11.9774 17.4399 11.9874 17.4925 11.947C17.5451 11.9067 17.555 11.8313 17.5147 11.7788C17.4743 11.7262 17.399 11.7163 17.3464 11.7566C17.2938 11.797 17.2839 11.8723 17.3243 11.9249Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3498 11.65L15.3963 10.7166L15.8111 10.1886L15.2831 10.6035L14.3498 11.65Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.781 12.2021C16.8063 12.2633 16.8765 12.2924 16.9377 12.2671C16.999 12.2417 17.0281 12.1715 17.0027 12.1103C16.9773 12.049 16.9071 12.02 16.8459 12.0453C16.7847 12.0707 16.7556 12.1409 16.781 12.2021Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9789 11.1667L15.2314 10.536L15.7687 10.1334L15.1514 10.3975L13.9789 11.1667Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1844 12.3293C16.1931 12.395 16.2533 12.4412 16.319 12.4326C16.3848 12.4239 16.431 12.3637 16.4224 12.298C16.4137 12.2323 16.3534 12.186 16.2877 12.1947C16.222 12.2033 16.1758 12.2636 16.1844 12.3293Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7458 10.604L15.1188 10.3189L15.7421 10.0691L15.0774 10.1644L13.7458 10.604Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5753 12.2977C15.5666 12.3634 15.6129 12.4237 15.6786 12.4324C15.7443 12.441 15.8046 12.3948 15.8132 12.3291C15.8219 12.2634 15.7756 12.2031 15.7099 12.1944C15.6442 12.1858 15.5839 12.232 15.5753 12.2977Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6663 10.0001L15.0663 10.0801L15.733 10.0001L15.0663 9.92007L13.6663 10.0001Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9951 12.1096C14.9697 12.1708 14.9988 12.241 15.06 12.2664C15.1212 12.2917 15.1914 12.2627 15.2168 12.2014C15.2421 12.1402 15.2131 12.07 15.1518 12.0447C15.0906 12.0193 15.0204 12.0484 14.9951 12.1096Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7458 9.39616L15.0774 9.83578L15.7421 9.93105L15.1188 9.68123L13.7458 9.39616Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4833 11.7777C14.443 11.8303 14.4529 11.9056 14.5054 11.946C14.558 11.9863 14.6334 11.9764 14.6737 11.9238C14.714 11.8712 14.7041 11.7959 14.6515 11.7556C14.599 11.7152 14.5236 11.7251 14.4833 11.7777Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9789 8.8334L15.1514 9.60269L15.7687 9.86674L15.2314 9.46412L13.9789 8.8334Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0749 11.3247C14.0223 11.365 14.0124 11.4403 14.0527 11.4929C14.0931 11.5455 14.1684 11.5554 14.221 11.5151C14.2736 11.4747 14.2835 11.3994 14.2431 11.3468C14.2028 11.2942 14.1275 11.2843 14.0749 11.3247Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3498 8.35016L15.2831 9.39667L15.8111 9.81151L15.3963 9.28354L14.3498 8.35016Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7976 10.7814C13.7364 10.8067 13.7073 10.8769 13.7327 10.9381C13.7581 10.9994 13.8283 11.0285 13.8895 11.0031C13.9507 10.9777 13.9798 10.9075 13.9544 10.8463C13.9291 10.7851 13.8589 10.756 13.7976 10.7814Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.833 7.97935L15.4637 9.23178L15.8663 9.76913L15.6023 9.15178L14.833 7.97935Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6705 10.1848C13.6047 10.1935 13.5585 10.2537 13.5671 10.3194C13.5758 10.3851 13.6361 10.4314 13.7018 10.4228C13.7675 10.4141 13.8137 10.3538 13.8051 10.2881C13.7964 10.2224 13.7362 10.1762 13.6705 10.1848Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3958 7.74624L15.6808 9.11925L15.9307 9.74249L15.8354 9.07783L15.3958 7.74624Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.702 9.57567C13.6363 9.56701 13.576 9.61327 13.5674 9.67898C13.5587 9.74468 13.605 9.80496 13.6707 9.81361C13.7364 9.82226 13.7967 9.77601 13.8053 9.7103C13.814 9.64459 13.7677 9.58432 13.702 9.57567Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 7.66674L15.9197 9.06674L15.9997 9.7334L16.0797 9.06674L15.9997 7.66674Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8901 8.99545C13.8289 8.97009 13.7587 8.99916 13.7334 9.06039C13.708 9.12162 13.7371 9.19182 13.7983 9.21718C13.8595 9.24254 13.9297 9.21346 13.9551 9.15224C13.9804 9.09101 13.9514 9.02081 13.8901 8.99545Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6036 7.74624L16.164 9.07783L16.0687 9.74249L16.3185 9.11925L16.6036 7.74624Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.222 8.48369C14.1695 8.44335 14.0941 8.45327 14.0538 8.50584C14.0134 8.55842 14.0234 8.63375 14.0759 8.6741C14.1285 8.71444 14.2038 8.70453 14.2442 8.65195C14.2845 8.59937 14.2746 8.52404 14.222 8.48369Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1663 7.97935L16.3971 9.15178L16.133 9.76913L16.5356 9.23178L17.1663 7.97935Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6751 8.07528C14.6347 8.0227 14.5594 8.01278 14.5068 8.05313C14.4542 8.09347 14.4443 8.1688 14.4847 8.22138C14.525 8.27396 14.6004 8.28388 14.6529 8.24353C14.7055 8.20319 14.7154 8.12786 14.6751 8.07528Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6496 8.35016L16.6031 9.28354L16.1882 9.81151L16.7162 9.39667L17.6496 8.35016Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2184 7.79803C15.193 7.7368 15.1228 7.70773 15.0616 7.73309C15.0004 7.75845 14.9713 7.82865 14.9967 7.88988C15.022 7.95111 15.0922 7.98018 15.1534 7.95482C15.2147 7.92946 15.2438 7.85926 15.2184 7.79803Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0204 8.8334L16.768 9.46412L16.2306 9.86674L16.848 9.60269L18.0204 8.8334Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8149 7.67085C15.8063 7.60515 15.746 7.55889 15.6803 7.56754C15.6146 7.57619 15.5683 7.63647 15.577 7.70218C15.5856 7.76789 15.6459 7.81414 15.7116 7.80549C15.7773 7.79684 15.8236 7.73656 15.8149 7.67085Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2535 9.39616L16.8805 9.68123L16.2573 9.93105L16.9219 9.83578L18.2535 9.39616Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4241 7.70241C16.4327 7.6367 16.3865 7.57642 16.3208 7.56777C16.2551 7.55912 16.1948 7.60537 16.1861 7.67108C16.1775 7.73679 16.2237 7.79707 16.2894 7.80572C16.3552 7.81437 16.4154 7.76811 16.4241 7.70241Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.333 10.0001L16.933 9.92007L16.2663 10.0001L16.933 10.0801L18.333 10.0001Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0043 7.89054C17.0297 7.82931 17.0006 7.75912 16.9394 7.73375C16.8781 7.70839 16.8079 7.73747 16.7826 7.7987C16.7572 7.85993 16.7863 7.93012 16.8475 7.95549C16.9087 7.98085 16.9789 7.95177 17.0043 7.89054Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2535 10.604L16.9219 10.1644L16.2573 10.0691L16.8805 10.3189L18.2535 10.604Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5161 8.22244C17.5564 8.16986 17.5465 8.09453 17.4939 8.05418C17.4413 8.01384 17.366 8.02376 17.3256 8.07633C17.2853 8.12891 17.2952 8.20424 17.3478 8.24459C17.4004 8.28493 17.4757 8.27502 17.5161 8.22244Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0204 11.1667L16.848 10.3975L16.2306 10.1334L16.768 10.536L18.0204 11.1667Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9245 8.67548C17.977 8.63513 17.987 8.5598 17.9466 8.50722C17.9063 8.45464 17.8309 8.44473 17.7784 8.48507C17.7258 8.52542 17.7159 8.60075 17.7562 8.65333C17.7966 8.7059 17.8719 8.71582 17.9245 8.67548Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6496 11.65L16.7162 10.6035L16.1882 10.1886L16.6031 10.7166L17.6496 11.65Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2017 9.21878C18.2629 9.19342 18.292 9.12323 18.2667 9.062C18.2413 9.00077 18.1711 8.97169 18.1099 8.99705C18.0486 9.02241 18.0196 9.09261 18.0449 9.15384C18.0703 9.21507 18.1405 9.24415 18.2017 9.21878Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1663 12.0208L16.5356 10.7684L16.133 10.231L16.3971 10.8484L17.1663 12.0208Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3289 9.81534C18.3946 9.80668 18.4409 9.74641 18.4322 9.6807C18.4236 9.61499 18.3633 9.56874 18.2976 9.57739C18.2319 9.58604 18.1856 9.64632 18.1943 9.71202C18.2029 9.77773 18.2632 9.82399 18.3289 9.81534Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6036 12.2539L16.3185 10.8809L16.0687 10.2577L16.164 10.9223L16.6036 12.2539Z",
    fill: "#000088"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_557_147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20,
    rx: 2.66667,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/india.a1ee2d88e948bd06647099f570c06290.svg";
export { ForwardRef as ReactComponent };